(() => {
  const init = () => {
    document.querySelectorAll('.steinara-magazine .rte-table-wrapper').forEach((wrapper, index) => {
      if (wrapper.dataset.magazineReady) return;
      wrapper.dataset.magazineReady = 'true';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      const caption = wrapper.querySelector('caption');
      if (caption) {
        if (!caption.id) caption.id = `steinara-table-caption-${index + 1}`;
        wrapper.setAttribute('aria-labelledby', caption.id);
      } else {
        wrapper.setAttribute('aria-label', wrapper.closest('.steinara-magazine').dataset.tableScrollLabel);
      }
    });
  };
  const start = () => {
    init();
    document.querySelectorAll('.steinara-magazine rte-formatter').forEach((formatter) => {
      new MutationObserver(init).observe(formatter, { childList: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
